import {
    Directive,
    ElementRef,
    Inject,
    Input,
    OnDestroy,
    Renderer2
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, pluck, takeUntil } from 'rxjs/operators';

/** [sbContainerSpacer] directive to add padding to the top of the container to account for height of navbar with fixed position. The height of the navbar may change if content doesn't fit or if user is being impersonated, and we show an impersonation notice. It's a "temporary" fix for our legacy layout until we've refactored it.
 */
@Directive({
    selector: '[sbContainerSpacer]',
    standalone: true
})
export class SbContainerSpacerDirective implements OnDestroy {
    @Input() styleProperty: 'padding-top' | 'top' = 'padding-top';
    unsubscribe$ = new Subject();
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        @Inject(DOCUMENT) document: Document
    ) {
        // create an observable that emits when the navbar resizes
        const sizeChange$ = new Observable<ResizeObserverEntry>((subscriber) => {
            // create a resize observer
            const ro = new ResizeObserver((entries) => {
                subscriber.next(entries[0]);
            });
            // select navbar element
            const navbar = document.querySelector('app-sb-menu');

            // observe navbar
            ro.observe(navbar);

            // return an unsubscribe function
            return function unsubscribe() {
                ro.unobserve(navbar);
            };
        });

        // subscribe to the observable
        sizeChange$
            .pipe(
                pluck('contentRect', 'height'),
                distinctUntilChanged(),
                takeUntil(this.unsubscribe$)
            )
            .subscribe((height) => {
                // set the padding-top of the container to the height of the navbar
                this.renderer.setStyle(
                    elementRef.nativeElement,
                    this.styleProperty,
                    `${height}px`
                );
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
